import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getIdentityMounts(options = {}) {
	return _apiRequestWrap(
		ModulesMap.IDENTITY_MOUNTS,
		ModulesConfigMap[ModulesMap.IDENTITY_MOUNTS].GET_IDENTITY_MOUNTS,
		options
	)
}

function _getIdentityMount(options = {}) {
	return _apiRequestWrap(
		ModulesMap.IDENTITY_MOUNTS,
		ModulesConfigMap[ModulesMap.IDENTITY_MOUNTS].GET_IDENTITY_MOUNT,
		options
	)
}

function _createIdentityMount(options = {}) {
	return _apiRequestWrap(
		ModulesMap.IDENTITY_MOUNTS,
		ModulesConfigMap[ModulesMap.IDENTITY_MOUNTS].CREATE_IDENTITY_MOUNT,
		options
	)
}

function _patchIdentityMount(options = {}) {
	return _apiRequestWrap(
		ModulesMap.IDENTITY_MOUNTS,
		ModulesConfigMap[ModulesMap.IDENTITY_MOUNTS].PATCH_IDENTITY_MOUNT,
		options
	)
}

function _deleteIdentityMount(options = {}) {
	return _apiRequestWrap(
		ModulesMap.IDENTITY_MOUNTS,
		ModulesConfigMap[ModulesMap.IDENTITY_MOUNTS].DELETE_IDENTITY_MOUNT,
		options
	)
}

export default {

	[ModulesConfigMap[ModulesMap.IDENTITY_MOUNTS].GET_IDENTITY_MOUNTS]: _getIdentityMounts,

	[ModulesConfigMap[ModulesMap.IDENTITY_MOUNTS].GET_IDENTITY_MOUNT]: _getIdentityMount,

	[ModulesConfigMap[ModulesMap.IDENTITY_MOUNTS].CREATE_IDENTITY_MOUNT]: _createIdentityMount,

	[ModulesConfigMap[ModulesMap.IDENTITY_MOUNTS].PATCH_IDENTITY_MOUNT]: _patchIdentityMount,

	[ModulesConfigMap[ModulesMap.IDENTITY_MOUNTS].DELETE_IDENTITY_MOUNT]: _deleteIdentityMount,
}